import iitmlogo from "../assets/images/logo.webp";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

import {
  HeaderWrapper,
  NavBar,
  Logo,
  Menu,
  ActionButton,
  NavLink,
  Hamburger,
  MobileOverlay,
  ModalOverlay,
  ModalContent,
  CloseButton
} from "./Header.styles";

const Header = () => {
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (!menuOpen) return;
    const handleScroll = () => setMenuOpen(false);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [menuOpen]);

  /* Load HubSpot script only once */
useEffect(() => {
  if (!showForm) return;

  const loadForm = () => {
    if (window.hbspt) {
      const container = document.getElementById("about-hubspot-form");
      if (container) {
        container.innerHTML = "";

        window.hbspt.forms.create({
          region: "na2",
          portalId: "46890133",
          formId: "b67c2bd0-1361-4824-83f4-64ea65ea391f",
          target: "#about-hubspot-form",
        });
      }
    }
  };

  if (window.hbspt) {
    loadForm();
  } else {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.onload = loadForm;
    document.body.appendChild(script);
  }
}, [showForm]);

  return (
    <HeaderWrapper>
      <NavBar>
        {/* LOGO */}
        <Logo>
          <a href="/">
            <img src={iitmlogo} alt="IIT Madras Logo" />
          </a>
        </Logo>

        {/* MENU */}
        <Menu open={menuOpen}>
          <ul>
            <li>
              <NavLink
                href="https://sociity.in/"
                active={location.hash === "https://sociity.in/"}
                onClick={closeMenu}
              >
                Home
              </NavLink>
            </li>

            <li>
              <NavLink
                href="#technology-summit"
                active={location.hash === "#technology-summit"}
                onClick={closeMenu}
              >
                About Summit
              </NavLink>
            </li>

            <li>
              <NavLink
                href="#inaugural-session"
                active={location.hash === "#inaugural-session"}
                onClick={closeMenu}
              >
                Inaugural Session
              </NavLink>
            </li>

            <li>
              <NavLink
                href="#tech-showcase"
                active={location.hash === "#tech-showcase"}
                onClick={closeMenu}
              >
                Technology Showcase
              </NavLink>
            </li>

            <li>
              <NavLink
                href="#impact-showcase"
                active={location.hash === "#impact-showcase"}
                onClick={closeMenu}
              >
                Impact Showcase
              </NavLink>
            </li>

            <li>
              <NavLink
                href="#valedictory-session"
                active={location.hash === "#valedictory-session"}
                onClick={closeMenu}
              >
                Valedictory Session
              </NavLink>
            </li>

            <li>
              <NavLink
                href="#partnership-awards"
                active={location.hash === "#partnership-awards"}
                onClick={closeMenu}
              >
                Partnership Awards
              </NavLink>
            </li>

            <li>
              <NavLink
                href="#event-photos"
                active={location.hash === "#event-photos"}
                onClick={closeMenu}
              >
                Event Photos 
              </NavLink>
            </li>
          </ul>
        </Menu>

        {/* REGISTER BUTTON */}
        {/* <ActionButton
          onClick={() => {
            // Trigger LinkedIn conversion
            if (window.lintrk) {
              window.lintrk('track', { conversion_id: 24571372 });
            }          
            // Open form
            setShowForm(true);
          }}
        >
          Register for the Summit
        </ActionButton> */}

        {/* HAMBURGER */}
        <Hamburger onClick={() => setMenuOpen(!menuOpen)}>
          <span />
          <span />
          <span />
        </Hamburger>
      </NavBar>

      {/* MOBILE OVERLAY — closes menu on outside click */}
      <MobileOverlay open={menuOpen} onClick={closeMenu} />

      {/* MODAL */}
      {showForm && (
  <ModalOverlay onClick={() => setShowForm(false)}>
    <ModalContent onClick={(e) => e.stopPropagation()}>
      
      <CloseButton onClick={() => setShowForm(false)}>
        ×
      </CloseButton>

      <div id="about-hubspot-form"></div>

    </ModalContent>
  </ModalOverlay>
)}
    </HeaderWrapper>
  );
};

export default Header;